import Vue from 'vue'
import VueRouter from 'vue-router'
import { getUserInfo , getSessionObj } from './common/utils'
import './common/bridge';
Vue.use(VueRouter);
const router = new VueRouter({
    routes: [
        {
            path: '/',
            redirect: '/home',
        },
        {
            path: '/home',
            name: 'home',
            components: require('./components/Home'),
            meta: {
                title: '产品详情'
            },
            children:[
                {
                    path: '/home/InsClause',
                    name: 'InsClause',
                    components: require('./components/InsClause'),
                }, {
                    path: '/home/InsNotice',
                    name: 'InsNotice',
                    components: require('./components/InsNoticeHome'),
                }, {
                    path: '/home/GuaranteeRes',
                    name: 'GuaranteeRes',
                    components: require('./components/GuaranteeRes'),
                }, {
                    path:'/home/deductible',
                    name:'Deductible',
                    components:require('./components/Deductible')
                }, {
                    path:'/home/CustomerPage',
                    name:'CustomerPage',
                    components:require('./components/CustomerPage')
                },{
                    path:'/home/rateDescription',
                    name:'rateDescription',
                    components:require('./components/rateDescription')
                }
            ]
        },
        {
            path: '/insure',
            name: 'insure',
            components: require('./components/Insure'),
            meta: {
                title: '预交保费信息'
            },
            children:[
                {
                    path: '/insure/InsClause',
                    name: 'InsClause',
                    components: require('./components/InsClause'),
                }, {
                    path: '/insure/InsNotice',
                    name: 'InsNotice',
                    components: require('./components/InsNoticeHome'),
                }
            ]
        },
        {
            path: '/certificate',
            name: 'certificate',
            components: require('./components/Certificate'),
            meta: {
                title: '小保单投保'
            },
            children:[
                {
                    path: '/certificate/InsClause',
                    name: 'InsClause',
                    components: require('./components/InsClause'),
                }, {
                    path: '/certificate/InsNotice',
                    name: 'InsNotice',
                    components: require('./components/InsNotice'),
                },
                {
                    path: '/certificate/InsClause1',
                    name: 'InsClause',
                    components: require('./components/InsClause1'),
                },
                {
                    path: '/certificate/CustomerPage',
                    name: 'CustomerPage',
                    components: require('./components/CustomerPage'),
                },
            ]
        },
        {
            path: '/recharge',
            name: 'recharge',
            components: require('./components/recharge'),
            meta: {
                title: '预缴'
            },
        },
        {
            path: '/clausePage',
            name: 'clausePage',
            components: require('./components/clausePage.vue'),
            meta: {
                title: '条款信息'
            },
        },
        {
            path: '/activePage',
            name: 'activePage',
            components: require('./components/active/index.vue'),
            meta: {
                title: '车王争霸赛'
            },
        },
        {
            path: '/listPage',
            name: 'listPage',
            components: require('./components/active/listPage.vue'),
            meta: {
                title: '榜单'
            },
        },
        {
            path: '/offLineSuccess',
            name: 'offLineSuccess',
            components: require('./components/success/offLineSuccess.vue'),
            meta: {
                title: '榜单'
            },
        },
        {
          path: "/notice",
          name: "notice",
          components: require("./components/notice/index.vue"),
          meta: {
            title: "客户告知书",
          },
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
router.beforeEach((to, from, next) => {
    // console.log(to);
    // const title = to.meta && to.meta.title;
    // if (title) document.title = title;
    // 路由跳转后稍等一下记录
    setTimeout(() => {
        sessionStorage.setItem("currentRouterName",to.name)
    }, 50);
    if (navigator.userAgent.indexOf("daka") > -1 && !getSessionObj("dakaUser")) {
		new Promise((resolve) => {
			getUserInfo(resolve)
		}).then(() => {
			next({to})
		})
	}else {
		next({to});
	}     
});
export default router
